<template> 
    <div 
      class="wrapper" 
      ref="wrapperRef" 
      v-loading="loading"
    >
      <div ref="contentRef">
        <div>
          <slot></slot>
        </div>
      </div>
    </div> 
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick, watch, computed,defineProps,defineEmits,defineExpose } from 'vue';
import BScroll from 'better-scroll';

const loading = ref(true)
let bscroll = {}
let observer = null;
const wrapperRef = ref(null); 

const refresh = function(){ 
if(bscroll.refresh){
bscroll.refresh(); 
}else{
initScrollArea();
}
}

const initScrollArea = function(){
    // if (!wrapperRef.value) return;
    // if(bscroll.refresh){
    // bscroll.refresh();
    // return false;
    // } 
    nextTick(()=>{
    bscroll = new BScroll(wrapperRef.value, {
    //开启点击事件 默认为false
    click:true,
    scrollbar: {
    fade: false,
    interactive: false // 1.8.0 新增
    },
    mouseWheel: {
    speed: 20,
    invert: false,
    easeTime: 300
    },
    probeType:3
    })
    loading.value = false;
    })
    }
onMounted(()=>{
  nextTick(()=>{
    initScrollArea()
  })

  // 当事情发生变化时调用`update`
      observer = new MutationObserver(refresh);

      // 观察这个组件的变化
      observer.observe(wrapperRef.value, {
        childList: true,
        subtree: true
      });


})
 
</script>

<style scoped>
.wrapper {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.wrapper:deep(.bscroll-vertical-scrollbar) {
  z-index: 1 !important;
}
</style>